
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { DeviceAPI } from "@/common/api/deviceManage/deviceList";
import { CommonApi } from "@/common/api/common";

import PandaDownloadBtn from '@/components/downloadQRCode.vue';


// import { excuteDownloadExport2Excel } from "@/common/xlsx";
export const pageApiList = getPageAPIs(DeviceAPI);

import {
  // transferUserLevel2ch,
  defaultUserMemberList,
  getCommonList
} from "@/common/config";

// 类型:设备类型：1 智能开关 2氛围灯 3AI板
const deviceType2Ch: string[] = ['', '智能开关', '氛围灯', 'AI板']

//绑定状态 0全部 1已绑定 2未绑定
const deviceBindStatus2Ch: string[] = ['', '已绑定', '未绑定']

// 是否绑定设备 0否  非0 是
const deviceStatus2Tag: any[] = [
  {
    type: 'danger',
    label: '未绑定'
  },
  {
    type: '',
    label: '已绑定'
  }
]

@Component({
  filters: {
    showDeviceTypeName(type: number) {
      return deviceType2Ch[type] || '未知'
    }
  },
  components: {
    PandaDownloadBtn,
  },
})
export default class UserList extends Vue {
  private utilInstance: any;
  private deviceApi: any;

  private commonApi: any;

  private deviceStatus2Tag: any[] = [
    ...deviceStatus2Tag
  ]


  constructor() {
    super();
    this.deviceApi = new DeviceAPI();

    this.commonApi = new CommonApi();

    this.utilInstance = new Util();

    // 封禁时间列表
    // this.all_forbidden_time_list = Util.getFoibiddenTimeList();
  }

  private firstLoading: boolean = true;

  private form: any = {
    device_name: "", // 设备名称
    product_id: "", // 设备ID
    bind_stat: 0, // 绑定状态 0全部 1已绑定 2未绑定
  };

  private bindStatusList: any[] = [
    ...getCommonList(deviceBindStatus2Ch, 1)
  ]

  private activated(): void {
    this.getTable();
  }
  private getTable(): void {
    this.deviceApi.getDeviceTableList(
      this.getDeviceTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  private getDeviceTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      product_id, // 设备ID
      // userName, // 用户昵称
      device_name, // 设备名称
      // time, // 时间选择
      bind_stat
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {
      bind_stat
    };

    if (product_id) {
      outerParams.product_id = product_id;
    }


    if (device_name) {
      outerParams.device_name = device_name;
    }

    // if (Array.isArray(time) && time.length === 2) {
    //   const [startDate, endDate] = time;

    //   const startTime = Util.dateTimeUtilnohms(startDate);
    //   const endTime = Util.dateTimeUtilnohms(endDate);

    //   outerParams.created_start_time = startTime;

    //   outerParams.created_end_time = endTime;
    // }

    // if (
    //   mode == "exportExcel" &&
    //   !(outerParams.created_start_time && outerParams.created_end_time)
    // ) {
    //   this.$message.error("请选择时段导出数据");
    //   return null;
    // }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {} = data;

    const newData = {
      ...data,
    };

    return newData;
  }


  private createDeviceIdLoading: boolean = false;

  private onCreateDeviceGateId() {
    this.createDeviceIdLoading = true
    this.deviceApi.createBatchDeviceGateId({

    }, () => {
      this.createDeviceIdLoading = false
      this.getTable()
    }, () => {
      this.createDeviceIdLoading = false
    })
  }

  // 查看用户订单
  // private handleGoUserOrderList(userItem: any): void {
  //   console.log(userItem, "userItem");

  //   const { id: userId } = userItem || {};

  //   if (userId) {
  //     this.$router.push({
  //       path: "/orderList",
  //       query: {
  //         userId,
  //       },
  //     });
  //   }
  // }

  /** 导出excel */
  // private downloadExcelLoading: boolean = false;

  // // 用户字段名 文案对应关系
  // private userExcelList2ch: any = {
  //   id: "用户ID",
  //   user_name: "用户昵称",
  //   phone: "用户手机号",
  //   gender_name: "性别",
  //   invite_code: "邀请码",
  //   birthday: "生日",
  //   user_level_name: "会员等级",
  //   created_at: "注册时间",
  //   account_status_name: "账户状态",
  // };
  // // 用户Excel 表头的先后顺序
  // private userExcelSortList: string[] = [
  //   "id",
  //   "user_name",
  //   "phone",
  //   "gender_name",
  //   "invite_code",
  //   "birthday",
  //   "user_level_name",
  //   "created_at",
  //   "account_status_name",
  // ];

  // // 点击导出excel 表格
  // private handleDownloadExcel() {
  //   const params = this.getDeviceTableListParams("exportExcel");

  //   if (params === null) {
  //     return false;
  //   }

  //   this.downloadExcelLoading = true;
  //   this.deviceApi.exportExcelUserList(
  //     params,
  //     (res: any) => {
  //       const { created_start_time, created_end_time } = params || {};

  //       const filename = `用户列表 ${created_start_time}到${created_end_time}.xlsx`;
  //       const { data } = res || {};

  //       const { list: originList } = data || {};

  //       const newList = Array.isArray(originList)
  //         ? originList.map((item) => {
  //             const { gender, type, status } = item;
  //             const newItem = {
  //               ...(item || {}),
  //             };

  //             // if (!forbidTime) {
  //             newItem.gender_name = this.transferGender2ch[gender];

  //             newItem.user_level_name = this.transferUserLevel2ch[type];

  //             newItem.account_status_name =
  //               this.transferUserAccountStatus2ch[status];
  //             // }

  //             return newItem;
  //           })
  //         : [];

  //       if (newList.length > 0) {
  //         const userExcelSortList = this.userExcelSortList;

  //         const userExcelList2ch = this.userExcelList2ch;

  //         const excelJSONData = getExcelJSONDataByList(
  //           newList,
  //           userExcelSortList,
  //           userExcelList2ch
  //         );

  //         excuteDownloadExport2Excel(excelJSONData, filename);
  //       } else {
  //         this.$message.info("选中时段没有可导出的信息");
  //       }

  //       this.downloadExcelLoading = false;
  //     },
  //     () => {
  //       this.downloadExcelLoading = false;
  //     }
  //   );
  // }

  /** end 导出excel */

  private restForm(): void {
    this.form = this.utilInstance.clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
